import ProjectQaWeldingInspectionsIndex from "./index"
import NewProjectQaWeldingInspections from "./new"
import EditProjectQaWeldingInspections from "./edit"

export default [
  { path: '/project/:project_id/qa/welding_inspections/:id/edit', component: EditProjectQaWeldingInspections, name: 'Edit ProjectQaWeldingInspection' },
  { path: '/project/:project_id/qa/welding_inspections/new', component: NewProjectQaWeldingInspections, name: 'New ProjectQaWeldingInspection' },
  { path: '/project/qa/welding_inspections', component: ProjectQaWeldingInspectionsIndex, name: 'ProjectQaWeldingInspections' },
]

// import ProjectQaWeldingInspectionsRoutes from "modules/project/qa/welding_inspections/mobile/routes"
// routes = _.concat(routes,ProjectQaWeldingInspectionsRoutes)
